import React from "react";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";

interface OnboardingWelcomeProps {
  onStart: () => void;
}

const OnboardingWelcome: React.FC<OnboardingWelcomeProps> = ({ onStart }) => {
  const { onboarding, resetOnboarding } = useOnboardingState();
  const { isAgency, role } = useAuth();
  const { toast } = useToast();

  const canReset = isAgency?.() || role === "admin";

  const handleReset = async () => {
    const ok = await resetOnboarding?.();
    toast({
      title: ok ? "Onboarding reset" : "Reset failed",
      description: ok
        ? "Your tenant is back to Step 1 (Twilio)."
        : "We couldn't reset onboarding. Please try again.",
      variant: ok ? "default" : "destructive",
    });
  };

  const completed = onboarding?.status === "completed";

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Welcome to Calie.ai</h1>
      <p className="mb-6">{completed ? "Setup completed. You can re-run the wizard or reset if needed." : "Complete the setup wizard to start tracking your calls."}</p>

      <div className="flex items-center gap-3">
        <Button onClick={onStart}>
          {completed ? "Re-run Wizard" : (onboarding ? "Resume Setup" : "Start Setup")}
        </Button>
        {canReset && (
          <Button variant="outline" onClick={handleReset}>
            Reset onboarding
          </Button>
        )}
      </div>
    </div>
  );
};

export default OnboardingWelcome;
